import React from "react";
import styles from "./mentalmath.module.css";
import AdvantageItem from "./AdvantageItem";


const AdvantagesSection = ({ advantages, heading, subheading }) => {

    return (
        <section className={styles.advantagesSection}>
            <h2 className={styles.advantagesHeading}>
                <span className={styles.advantagesPart1}>
                    {heading}
                </span>
                <br />
                <span className={styles.advantagesPart2}>   {subheading}</span>
            </h2>
            <div className={styles.advantagesGrid}>
                {advantages.map((advantage, index) => (
                    <AdvantageItem key={index} advantage={advantage} />
                ))}
            </div>
        </section>
    );
};

export default AdvantagesSection;
